import { Table, Space, Button, Row, Col, Tooltip, Pagination, Input } from "antd";
import { SendOutlined, FilePdfOutlined, SearchOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import AddCreditNoteModal from "./AddCreditNote";
import { creditNoteService, dropdownService } from "../../../../../services";
import { Link } from "react-router-dom";
import { handlePDFDownload, handlePrint, exportToExcel } from "../../../../../utils/printing";
import { changeDocumentTitle } from "../../../../../utils/title";
import { useDebounce } from "../../../../../hooks/useDebounce";
import { FaSleigh } from "react-icons/fa";

function CreditNotes() {
  const [loading, setLoading] = useState(false);
  const [creditNote, setCreditNote] = useState([]);
  const [allcreditNote, setAllCreditNote] = useState([]);
  const [search, setSearch] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [invoices, setInvoices] = useState([]);
  const [isModalShow, setIsModalShow] = useState(false);

  const debouncedSearch = useDebounce(search, 500);

  const showModal = () => setIsModalShow(true);

  const columns = [
    {
      title: "SAV",
      dataIndex: "SAV",
      key: "SAV",
      render: (_, __, index) =>
        ((pagination.current - 1) * pagination.pageSize + index + 1).toString().padStart(5, "0"),
    },
    {
      title: "Credit Number",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Issue Date",
      dataIndex: "issue_date",
      key: "issue_date",
    },
    {
      title: "Invoice",
      dataIndex: "invoice_id",
      key: "invoice_id",
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: "30%",
    },

    {
      title: "Action",
      key: "Action",
      className: "no-print",
      render: (text, record, { _id }) => (
        <Space size="small">
          <Tooltip title='Send'>
            {/* <Button type="primary" size="small"> */}
            <SendOutlined style={{ fontSize: 12 }} />
            {/* </Button> */}
          </Tooltip>

          <Link to={`/accounts/credit-notes/PDF/${record.id}`} className="hover:text-primary">
            <Tooltip title='Pdf'>
              {/* <Button type="primary" size="small"> */}
              <FilePdfOutlined style={{ fontSize: 12 }} />
              {/* </Button> */}
            </Tooltip>
          </Link>
        </Space>
      ),
    },
  ];

  const initialize = async (page = 1, pageSize = pagination.current,) => {
    setLoading(true);
    const { success, data } = await creditNoteService.fetch(page, pageSize, false, debouncedSearch);
    if (success) {
      setCreditNote(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
    setLoading(false);
  };

  const getInvoices = async () => {
    const response = await dropdownService.fetchInvoices();
    if (response.success) {
      const filteredInvoices = response.data.filter((i) => i.is_partial != 2);
      setInvoices(filteredInvoices);
    }
  };

  const getAll = async () => {
    const res = await creditNoteService.fetch(1, 10, true)
    if (res.success) {
      setAllCreditNote(res.data)
    }
  }
  useEffect(() => {
    getInvoices();
    getAll()
  }, [])

  useEffect(() => {
    changeDocumentTitle("Credit Notes");
    initialize(pagination.current, pagination.pageSize);
  }, [debouncedSearch]);


  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <div className="flex justify-between items-center">
        <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
          Credit Notes
        </h1>
        <Input
          placeholder="Search by Credit No , Invoice No & Customer"
          prefix={<SearchOutlined />}
          style={{
            width: "37%",
            borderRadius: "20px",
            fontSize: 14,
            margin: 10
          }}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>


      {/* <Divider style={{ marginTop: 10 }} /> */}
      <Row
        gutter={8}
        style={{
          marginTop: "5px",
          background: "#F2F2F7",
          padding: "5px",
          alignItems: "center", // Ensures alignment of items within the row
        }}
      >
        {/* <Col
          span={4}
          xs={24}
          sm={12}
          md={6}
          lg={4}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Space direction="horizontal" size={10}>
            <p style={{ margin: 0 }}>Show</p>
            <Select
              defaultValue={10}
              options={options}
              onChange={(value) => initialize(1, value)}
              size="small"
              style={{ width: 70, fontSize: 14 }}
            />
            <p style={{ margin: 0 }}>entries</p>
          </Space>
        </Col> */}

        {/* Second Column: Right-Aligned Search */}
        <Col
          span={24}
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          <Button
            type="primary"
            onClick={showModal}>
            Add Credit Note
          </Button>
        </Col>
      </Row>
      <Row
        gutter={8}
        style={{
          marginTop: "6px",
          background: "#F2F2F7",
          padding: "10px",
          borderRadius: "4px",
        }}
        className="flex justify-between"
      >
        <Col span={12}>
          <div className="flex">
            <Button
              onClick={() => handlePrint(allcreditNote, columns, "Credit Notes Report")}
              type="primary"
              size="small"
              style={{ padding: "4px", margin: "0 5px 0 5px" }}
            >
              <span style={{ fontWeight: "bold", padding: "3px" }}>Print</span>
            </Button>

            <Button
              onClick={() => exportToExcel(allcreditNote, "Credit_notes.xlsx")}
              type="primary"
              size="small"
              style={{ padding: "4px", margin: "0 5px 0 5px" }}
            >
              <span style={{ fontWeight: "bold", padding: "3px" }}>Excel</span>
            </Button>

            <Button
              onClick={() => handlePDFDownload(allcreditNote, columns, "Credit Notes Report", false)}
              type="primary"
              size="small"
              style={{ padding: "4px", margin: "0 5px 0 5px" }}
            >
              <span style={{ fontWeight: "bold", padding: "3px" }}>PDF</span>
            </Button>

          </div>
        </Col>

        {/* <Col span={12} style={{ textAlign: "right" }}>
          <Input
            placeholder="Search"
            prefix={<SearchOutlined />}
            className="w-auto lg:w-2/5"
          />
        </Col> */}
      </Row>
      <AddCreditNoteModal
        isVisible={isModalShow}
        setIsModalShow={setIsModalShow}
        creditNote={creditNote}
        initialize={() => initialize(pagination.current, pagination.pageSize)}
      />
      <div id="printable-table">
        <Table
          columns={columns}
          scroll={{ x: "max-content" }}
          rowKey='id'
          dataSource={creditNote}
          pagination={false}
          loading={loading}
          style={{ marginTop: "10px" }}
          footer={() => (
            <div className="flex justify-between items-center text-xs ">
              <div className=" text-gray-600">
                Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
                {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
                {pagination.total} entries
              </div>
              <Pagination
                current={pagination.current}
                total={pagination.total}
                pageSize={pagination.pageSize}
                showSizeChanger={false}
                onChange={(page) => initialize(page, pagination.pageSize, false, search)}
                itemRender={(current, type, originalElement) => {
                  if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                  if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                  return originalElement;
                }}
              />
            </div>
          )}
        />
      </div>
    </div >
  );
}
export default CreditNotes;
